import React from "react";

export const Logo = ({ className = "", dark = false }) => {
  const c = dark ? "#F6F5F2" : "#052F24";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg width="44" height="44" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M6 40 L14 40 L14 30 L24 30 L24 20 L34 20" stroke={c} strokeWidth="5" strokeLinecap="square" strokeLinejoin="miter" fill="none"/>
        <path d="M30 12 L40 12 L40 22" stroke={c} strokeWidth="5" strokeLinecap="square" strokeLinejoin="miter" fill="none"/>
        <path d="M22 24 L40 12" stroke={c} strokeWidth="5" strokeLinecap="square"/>
      </svg>
      <span className="font-display font-extrabold tracking-tight text-2xl sm:text-[28px] leading-none" style={{ color: c }}>
        Growth<span style={{ color: dark ? "#DFFF00" : "#052F24" }}> Funds</span>
      </span>
    </div>
  );
};
